import { Link } from 'react-router-dom';

import { Box } from 'ui/Layout';

import Page from '../components/Page';
import { ReadOnlySankeyChart } from '../components/SankeyChart';
import { pathToSankey, useCurrentRouteSankeyId } from '../utils/routes';

const SankeyPreviewPage: React.FC = () => {
  const currentSankeyId = useCurrentRouteSankeyId();
  return (
    <Page>
      <Link to={pathToSankey(currentSankeyId)}>
        <Box
          cursor="pointer"
          title="Click to go back to the editor"
          overflowX="hidden"
          w="100vw"
          h="100vh"
        >
          <ReadOnlySankeyChart hasBorder={false} />
        </Box>
      </Link>
    </Page>
  );
};

export default SankeyPreviewPage;
